"use client";

import React from "react";
import { Separator } from "@/components/ui/separator";
const metrics = [{
  label: "Throughput Logistico",
  value: "84.2 TEU/H",
  highlight: false
}, {
  label: "Corridoi Attivi",
  value: "12",
  highlight: false
}, {
  label: "Nodi Operativi",
  value: "47",
  highlight: false
}, {
  label: "Latenza Media",
  value: "1.2S",
  highlight: false
}, {
  label: "Stato Rete",
  value: "OTTIMALE",
  highlight: true
}];
const tickerItems = [...metrics, ...metrics, ...metrics, ...metrics];
export default function AccessMetric() {
  return <section id="metrica-di-accesso" className="dark bg-background text-foreground relative w-full overflow-hidden border-y border-border/20 py-8 sm:py-12">
      <style>{`
        @keyframes brutalist-ticker {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-brutalist-ticker {
          animation: brutalist-ticker 60s linear infinite;
        }
        
        .animate-brutalist-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>

      {}
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary/5 via-background/0 to-background/0" />

      <div className="relative z-10 flex w-max items-center">
        <div className="animate-brutalist-ticker flex items-center">
          {tickerItems.map((item, i) => <div key={i} data-index={i} className="flex items-center">
              <div className="flex flex-col justify-center px-12 sm:px-24">
                <span className="mb-3 font-mono text-xs font-medium tracking-[0.3em] text-muted-foreground uppercase">
                  {item.label}
                </span>
                <span className={`font-mono text-4xl sm:text-6xl font-bold tracking-tighter ${item.highlight ? "text-primary drop-shadow-[0_0_8px_rgba(220,20,60,0.5)]" : "text-foreground"}`}>
                  {item.value}
                </span>
              </div>
              <Separator orientation="vertical" className="h-20 w-[1px] bg-border/30 sm:h-24" decorative />
            </div>)}
        </div>
      </div>
    </section>;
}